import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { authFetch } from "../../App";
import { FileText, ArrowRight } from "lucide-react";

const API = "/api";

export default function HpsBerichteListe() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await authFetch(`${API}/hps/reports`).then(x => x.json());
        setReports(Array.isArray(r) ? r : []);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="text-white/60 text-sm py-20 text-center">Lade Berichte …</div>;

  return (
    <div className="space-y-6" data-testid="hps-berichte-liste">
      <div>
        <h1 className="text-2xl font-semibold text-white">Berichte</h1>
        <p className="text-sm text-white/55 mt-1">Alle Prüfberichte im Überblick.</p>
      </div>

      {reports.length === 0 && (
        <div className="text-sm text-white/40 text-center py-12">Noch keine Berichte vorhanden.</div>
      )}

      <div className="space-y-2">
        {reports.map((r) => (
          <Link key={r.id} to={`/app/hps-anlagencheck/bericht/${r.id}`}
                data-testid={`hps-bericht-row-${r.id}`}
                className="block rounded-xl border border-white/10 p-4 hover:border-blue-400/40 hover:bg-white/5 transition-all"
                style={{ background: "rgba(255,255,255,0.03)" }}>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-start gap-3 min-w-0">
                <FileText className="w-4 h-4 text-blue-300 mt-1 shrink-0" />
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                    <span className="text-sm font-medium text-white truncate">{r.title}</span>
                    {r.is_demo && <span className="text-[10px] uppercase tracking-wider text-amber-300 bg-amber-500/15 border border-amber-400/30 rounded px-1.5 py-0.5">Demo</span>}
                  </div>
                  <div className="text-xs text-white/55">
                    Status: {r.status === "in_pruefung" ? "fachlich zu prüfen" : r.status}
                  </div>
                </div>
              </div>
              <ArrowRight className="w-4 h-4 text-white/40 shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
